import { Component, OnInit } from '@angular/core';
import { Company, Region } from 'src/app/core/models';
import { ModalService, RegionService } from 'src/app/core/services';
import { BaseModal } from 'src/app/core/utils/BaseModal';

@Component({
  selector: 'app-view-company',
  templateUrl: './view-company.component.html',
  styleUrls: ['./view-company.component.sass']
})
export class ViewCompanyComponent extends BaseModal implements OnInit {

  isValid: boolean;
  lastState: any;
  company: Company;
  public loading = false;
  public regionById: { [param: number]: Region } = {};

  constructor(
    modalService: ModalService,
    private regionService: RegionService
  ) {
    super(modalService);
  }

  async ngOnInit() {
    this.loading = true;
    this.company = this.initialState;
    await this.getRegions();
    this.loading = false;
  }

  async getRegions() {
    await this.regionService.list({}).then(res => {
      res.result.map(item => {
        this.regionById[item.id] = item;
      });
    });
  }

  async onAllSubmited(): Promise<any> {
  }

  convertCNPJ(cnpj) {
    if (!cnpj) {
      return;
    }
    return cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})$/, '$1.$2.$3/$4-$5');
  }

}
